/* prettier-ignore */
/**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */
//Chinese (Traditional)
export default {
  'company-hub.spotlight-extension.config-panel.preamble': '透過視覺聚光燈凸顯重要訊息。{supportLink}',
  'company-hub.spotlight-extension.config-panel.preamble-link.label': '進一步了解聚光燈',
  'company-hub.spotlight-extension.config-panel.preamble-without-support-link': '透過視覺聚光燈凸顯重要訊息。',
  'company-hub.spotlight-extension.config-panel.title': '聚光燈',
  'company-hub.spotlight-extension.hub-element.description': '凸顯重要訊息',
  'company-hub.spotlight-extension.hub-element.title': '聚光燈',
  'company-hub.spotlight-extension.manifest.initial-state.alt-image-text': '沙漠的橫式照片',
  'company-hub.spotlight-extension.manifest.initial-state.text-description':
    '設計聚光燈以凸顯您最重要的資訊。透過自訂顏色、強大的圖片和彈性版面配置，讓最重要的訊息更加生動。',
  'company-hub.spotlight-extension.manifest.initial-state.text-title': '為聚光燈提供標題',
  'company-hub.spotlight-extension.manifest.macro-description': '透過視覺聚光燈凸顯重要訊息。',
  'company-hub.spotlight-extension.manifest.macro-title': '聚光燈',
  'company-hub.spotlight-extension.manifest.macro-title.new': '聚光燈 [新功能]',
  'company-hub.spotlight-extension.spotlight-config-panel.content-tab.label': '內容',
  'company-hub.spotlight-extension.spotlight-config-panel.general-title': '一般',
  'company-hub.spotlight-extension.spotlight-config-panel.layouts-title': '版面配置',
  'company-hub.spotlight-extension.spotlight-config-panel.layouts.frame-above-image.description':
    '大型圖片上覆蓋文字方塊',
  'company-hub.spotlight-extension.spotlight-config-panel.layouts.frame-above-image.label': '圖片內的內容框架',
  'company-hub.spotlight-extension.spotlight-config-panel.layouts.image-background.description':
    '內容背後的完整尺寸圖片',
  'company-hub.spotlight-extension.spotlight-config-panel.layouts.image-background.label': '圖片背景',
  'company-hub.spotlight-extension.spotlight-config-panel.layouts.solid-color-background.description':
    '全寬度顏色前面的內容',
  'company-hub.spotlight-extension.spotlight-config-panel.layouts.solid-color-background.label': '純色背景',
  'company-hub.spotlight-extension.spotlight-config-panel.layouts.split-design-content-first.description':
    '右側的大圖片有很多顯示內容的空間',
  'company-hub.spotlight-extension.spotlight-config-panel.layouts.split-design-content-first.label':
    '分割設計 (內容優先)',
  'company-hub.spotlight-extension.spotlight-config-panel.layouts.split-design-image-first.description':
    '左側的大圖片有很多顯示內容的空間',
  'company-hub.spotlight-extension.spotlight-config-panel.layouts.split-design-image-first.label':
    '分割設計 (圖片優先)',
  'company-hub.spotlight-extension.spotlight-config-panel.styles-tab.label': '樣式',
  'company-hub.spotlight-extension.spotlight-config-panel.text-description-label': '描述',
  'company-hub.spotlight-extension.spotlight-config-panel.text-description-placeholder':
    '聚光燈會為您的團隊凸顯重要訊息。使用圖片、自訂顏色、簡短的描述和連結來設計您的聚光燈。',
  'company-hub.spotlight-extension.spotlight-config-panel.text-image-label': '圖片',
  'company-hub.spotlight-extension.spotlight-config-panel.text-title-label': '標題',
  'company-hub.spotlight-extension.spotlight-config-panel.text-title-placeholder': '為聚光燈提供標題',
  'company-hub.spotlight-extension.spotlight.background.color': '背景顏色',
  'company-hub.spotlight-extension.spotlight.color-contrast.fail': '您的文字和背景顏色搭配無法凸顯內容。',
  'company-hub.spotlight-extension.spotlight.color-contrast.success': '您的文字和背景顏色搭配可以凸顯內容。',
  'company-hub.spotlight-extension.spotlight.text.color': '文字顏色',
};
